const pageNameKey = "otaConfirmBackupProcessModal";

export const otaConfirmBackupProcessModalEn = {
  [pageNameKey]: {
    closeModalAriaLabel: "Close confirm backup process modal",
    title: "Confirm Backup Process",
    targetPathLabel: "Path to back up (subfolders and files included)",
    sourceMachineLabel: "Source machine",
    warningText:
      "Do you want to create a backup of all folders and files on the machine in the backup path? Please make sure, the machine is in maintenance mode. The backup process will be executed after your confirmation.",
    cancelButtonText: "Cancel",
    approveButtonText: "Approve",
    approveSuccessMessage: "Backup process approved successfully.",
    approveFailureMessage: "Failed to approve the backup process",
    approveErrorMessage: "Error approving the backup process",
  },
};

export const otaConfirmBackupProcessModalPtBr = {
  [pageNameKey]: {
    closeModalAriaLabel: "Fechar modal de confirmação do processo de backup",
    title: "Confirmar processo de backup",
    targetPathLabel: "Caminho para backup (subpastas e arquivos incluídos)",
    sourceMachineLabel: "Máquina de origem",
    warningText:
      "Deseja criar um backup de todas as pastas e arquivos na máquina no caminho de backup? Certifique-se de que a máquina está em modo de manutenção. O processo de backup será executado após sua confirmação.",
    cancelButtonText: "Cancelar",
    approveButtonText: "Aprovar",
    approveSuccessMessage: "Processo de backup aprovado com sucesso.",
    approveFailureMessage: "Falha ao aprovar o processo de backup",
    approveErrorMessage: "Erro ao aprovar o processo de backup",
  },
};

export const otaConfirmBackupProcessModalDe = {
  [pageNameKey]: {
    closeModalAriaLabel: "Modal zur Bestätigung des Backup-Prozesses schließen",
    title: "Backup-Prozess bestätigen",
    targetPathLabel:
      "Pfad für das Backup (Unterordner und Dateien eingeschlossen)",
    sourceMachineLabel: "Quellmaschine",
    warningText:
      "Möchten Sie ein Backup aller Ordner und Dateien auf der Maschine im Backup-Pfad erstellen? Bitte stellen Sie sicher, dass sich die Maschine im Wartungsmodus befindet. Der Backup-Prozess wird nach Ihrer Bestätigung ausgeführt.",
    cancelButtonText: "Abbrechen",
    approveButtonText: "Genehmigen",
    approveSuccessMessage: "Backup-Prozess erfolgreich genehmigt.",
    approveFailureMessage: "Backup-Prozess konnte nicht genehmigt werden",
    approveErrorMessage: "Fehler beim Genehmigen des Backup-Prozesses",
  },
};

export const otaConfirmBackupProcessModalZhHans = {
  [pageNameKey]: {
    closeModalAriaLabel: "关闭确认备份流程弹窗",
    title: "确认备份流程",
    targetPathLabel: "备份路径（包含子文件夹和文件）",
    sourceMachineLabel: "源设备",
    warningText:
      "您要在备份路径中为该设备上的所有文件夹和文件创建备份吗？请确保设备处于维护模式。备份流程将在您确认后执行。",
    cancelButtonText: "取消",
    approveButtonText: "批准",
    approveSuccessMessage: "备份流程已成功批准。",
    approveFailureMessage: "批准备份流程失败",
    approveErrorMessage: "批准备份流程时出错",
  },
};

export const otaConfirmBackupProcessModalIt = {
  [pageNameKey]: {
    closeModalAriaLabel:
      "Chiudi la finestra di conferma del processo di backup",
    title: "Conferma processo di backup",
    targetPathLabel: "Percorso di backup (sottocartelle e file inclusi)",
    sourceMachineLabel: "Macchina sorgente",
    warningText:
      "Vuoi creare un backup di tutte le cartelle e i file sulla macchina nel percorso di backup? Assicurati che la macchina sia in modalità manutenzione. Il processo di backup verrà eseguito dopo la tua conferma.",
    cancelButtonText: "Annulla",
    approveButtonText: "Approva",
    approveSuccessMessage: "Processo di backup approvato con successo.",
    approveFailureMessage: "Impossibile approvare il processo di backup",
    approveErrorMessage: "Errore durante l'approvazione del processo di backup",
  },
};

export const otaConfirmBackupProcessModalEs = {
  [pageNameKey]: {
    closeModalAriaLabel: "Cerrar modal de confirmación del proceso de respaldo",
    title: "Confirmar proceso de respaldo",
    targetPathLabel: "Ruta para respaldo (subcarpetas y archivos incluidos)",
    sourceMachineLabel: "Máquina de origen",
    warningText:
      "¿Desea crear un respaldo de todas las carpetas y archivos en la máquina en la ruta de respaldo? Asegúrese de que la máquina esté en modo de mantenimiento. El proceso de respaldo se ejecutará después de su confirmación.",
    cancelButtonText: "Cancelar",
    approveButtonText: "Aprobar",
    approveSuccessMessage: "Proceso de respaldo aprobado correctamente.",
    approveFailureMessage: "No se pudo aprobar el proceso de respaldo",
    approveErrorMessage: "Error al aprobar el proceso de respaldo",
  },
};

export const otaConfirmBackupProcessModalNl = {
  [pageNameKey]: {
    closeModalAriaLabel: "Bevestigingsvenster voor back-upproces sluiten",
    title: "Back-upproces bevestigen",
    targetPathLabel: "Pad voor back-up (submappen en bestanden inbegrepen)",
    sourceMachineLabel: "Bronmachine",
    warningText:
      "Wilt u een back-up maken van alle mappen en bestanden op de machine in het back-uppad? Zorg ervoor dat de machine in onderhoudsmodus staat. Het back-upproces wordt uitgevoerd na uw bevestiging.",
    cancelButtonText: "Annuleren",
    approveButtonText: "Goedkeuren",
    approveSuccessMessage: "Back-upproces succesvol goedgekeurd.",
    approveFailureMessage: "Back-upproces kon niet worden goedgekeurd",
    approveErrorMessage: "Fout bij het goedkeuren van het back-upproces",
  },
};

export const otaConfirmBackupProcessModalTr = {
  [pageNameKey]: {
    closeModalAriaLabel: "Yedekleme işlemini onaylama penceresini kapat",
    title: "Yedekleme İşlemini Onayla",
    targetPathLabel: "Yedeklenecek yol (alt klasörler ve dosyalar dahil)",
    sourceMachineLabel: "Kaynak makinesi",
    warningText:
      "Makinedeki yedekleme yolundaki tüm klasör ve dosyaların yedeğini oluşturmak istiyor musunuz? Lütfen makinenin bakım modunda olduğundan emin olun. Onayınız sonrasında yedekleme işlemi gerçekleştirilecektir.",
    cancelButtonText: "İptal etmek",
    approveButtonText: "Onaylamak",
    approveSuccessMessage: "Yedekleme işlemi başarıyla onaylandı.",
    approveFailureMessage: "Yedekleme işlemi onaylanamadı",
    approveErrorMessage: "Yedekleme işlemi onaylanırken hata oluştu",
  },
};
